/** @format */

// Parameterised home for non-NASCAR sanctioning bodies (`/arca`, `/grcup`).
// `/nascar` redirects here for symmetric linking and is sent back to `/`.
//
// SEO: When adding a new sanctioning body to the SanctioningBody enum,
// add the slug to server/backend/sitemaps.py so sitemap.xml stays in sync.

import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { Suspense } from "react";

import { lazyWithRetry } from "@/utils/lazyWithRetry";
import PageLoader from "@/utils/PageLoader";
import { RouteErrorComponent } from "@/utils/RouteErrorComponent";
import { SanctioningBodySchema } from "@/utils/sanctioningBody";

const SanctioningBodyHome = lazyWithRetry(
  () => import("@/pages/Home/SanctioningBodyHome")
);

export const Route = createFileRoute("/$sanctioningBody")({
  parseParams: ({ sanctioningBody }) => {
    const result = SanctioningBodySchema.safeParse(sanctioningBody);
    if (!result.success) {
      // Unknown slug → fall through to the root NotFound. parseParams
      // throws are caught by TanStack and routed to errorComponent /
      // notFoundComponent depending on the throw shape.
      throw notFound();
    }
    return { sanctioningBody: result.data };
  },
  beforeLoad: ({ params }) => {
    if (params.sanctioningBody === "nascar") {
      // /nascar is a symmetric alias for /
      throw redirect({ to: "/" });
    }
  },
  component: () => {
    const { sanctioningBody } = Route.useParams();
    return (
      <Suspense fallback={<PageLoader />}>
        <SanctioningBodyHome body={sanctioningBody} />
      </Suspense>
    );
  },
  errorComponent: RouteErrorComponent,
});
